import Blog from "@/Layouts/Blog";
import Contact from "@/Sections/Contact";
import { Head } from "@inertiajs/inertia-react";

export default () => {
    return (
        <Blog>
            <Head>
                <title>Mijn stofwisseling is vertraagd, wat nu?</title>
                <link rel="canonical" href={route("blogs.twenty-one")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="Een van de grootste fouten die wordt gemaakt bij het afvallen is dat een vertraagde stofwisseling ontstaat. Hierdoor wordt het afvallen steeds moeilijker, groeien frustratie en is de kans op een terugval groot! WE ARE – personal training Uden en Schijndel komt met de vier meest gemaakt fouten waardoor een vertraagde stofwisseling ontstaat. "
                />
                <meta
                    property="og:description"
                    content="Een van de grootste fouten die wordt gemaakt bij het afvallen is dat een vertraagde stofwisseling ontstaat. Hierdoor wordt het afvallen steeds moeilijker, groeien frustratie en is de kans op een terugval groot! WE ARE – personal training Uden en Schijndel komt met de vier meest gemaakt fouten waardoor een vertraagde stofwisseling ontstaat. "
                />
                <meta property="og:url" content={route("blogs.twenty-one")} />
                <meta property="og:type" content="article" />
                <meta
                    property="og:title"
                    content="Mijn stofwisseling is vertraagd, wat nu? - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/blog/vertraagde-stofwisseling.jpg"
                />
            </Head>

            <div className="bg-black">
                <div className="relative xs:h-[30vh] sm:h-[30vh] md:h-[65vh] lg:h-[65vh] pb-32">
                    <div>
                        <div className="absolute inset-0">
                            <picture>
                                <source
                                    srcSet="/assets/blog/webp/vertraagde-stofwisseling.webp"
                                    type="image/webp"
                                    alt="Vertraagde stofwisseling"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <source
                                    srcSet="/assets/blog/vertraagde-stofwisseling.jpg"
                                    type="image/jpeg"
                                    alt="Vertraagde stofwisseling"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <img
                                    src="/assets/blog/vertraagde-stofwisseling.jpg"
                                    alt="Vertraagde stofwisseling"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                            </picture>
                            <div
                                className="absolute inset-0 bg-gray-800 opacity-50 mix-blend-multiply"
                                aria-hidden="true"
                            />
                        </div>
                    </div>
                </div>
                <div className="xs:px-8 sm:px-8 md:px-16 lg:px-16 xs:py-12 sm:py-12 md:py-24 lg:py-24 max-w-7xl mx-auto">
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl break-words">
                        Mijn stofwisseling is vertraagd, wat nu?
                    </h1>
                    <p className="mt-4 text-gray-100 break-words">
                        Een van de grootste fouten die wordt gemaakt bij het
                        afvallen is dat een vertraagde stofwisseling ontstaat.
                        Hierdoor wordt het afvallen steeds moeilijker, groeien
                        frustratie en is de kans op een terugval groot! WE ARE –
                        personal training Uden en Schijndel komt met de vier
                        meest gemaakt fouten waardoor een vertraagde
                        stofwisseling ontstaat.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        1. Te weinig krachttraining
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Onderzoeken tonen aan dat krachttraining de ideale
                        manier is om je stofwisseling hoog te houden. Dit wordt
                        veroorzaakt doordat krachttraining je spiermassa
                        verhoogt. Hoe meer spiermassa je hebt, hoe meer
                        calorieën je verbrandt in rust en tijdens beweging.
                        Zelfs bij een kleine frequentie per week (1 of 2 keer)
                        heeft dit al invloed op je stofwisseling. Een veel
                        gebruikt onderzoek laat zien dat bij een krachttraining
                        van 11 minuten, die drie keer per week plaatsvindt, de
                        stofwisseling verhoogt met 125 calorieën per dag! (Kirk,
                        2009). Hierdoor is het van belang dat je de tijd die je
                        doorbrengt in de sportschool voor het grote deel bestaat
                        uit{" "}
                        <a
                            href={route("blogs.fourth")}
                            className="text-we-are-yellow"
                        >
                            krachttraining in plaats van cardio
                        </a>
                        . Daarnaast verliezen we ook steeds meer spiermassa
                        omdat we ouder worden of door het afvallen. Hierdoor is
                        het extra belangrijk dat je genoeg krachttraining doet
                        om dit tegen te gaan en je stofwisseling hoog te houden.
                        De snelheid waarmee we spiermassa kunnen verliezen lees
                        je in deze{" "}
                        <a
                            href={route("blogs.ninth")}
                            className="text-we-are-yellow"
                        >
                            blog
                        </a>
                        .
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        2. Structureel te weinig calorieën
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Wanneer we willen afvallen is het nodig om een
                        energietekort te veroorzaken. Hierdoor komt het lichaam
                        energie te kort en zal het onze vetreserves gaan
                        gebruiken om energie vrij te maken. Wanneer je snel en
                        veel wilt afvallen kun een vertraagde stofwisseling het
                        gevolg zijn. Studies tonen aan dat een inname van lager
                        dan 1000 calorieën een enorme impact heeft op je
                        stofwisseling. (Redman, 2009). Door een te lage inname
                        denkt het lichaam dat het in een tijd leeft waar
                        voedselschaarste is. Om de kans op overleven te verhogen
                        verlaagt je lichaam je stofwisseling zodat hij minder
                        onnodige energie verbruikt en zijn beperkte voorraden
                        kan gebruiken voor belangrijke doeleinden. Het gevolg is
                        dat mensen na verloop van tijd weer een verhoogde
                        dagelijkse calorie inname hanteren maar hun
                        stofwisseling nog vertraagd is. Het gevolg hiervan is
                        het bekende{" "}
                        <a
                            href={route("blogs.eighth")}
                            className="text-we-are-yellow"
                        >
                            jojo-effect
                        </a>
                        .
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        3. Te weinig eiwitten eten
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Het lichaam verbrandt door verschillende processen
                        calorieën zoals beweging. Een andere oorzaak is het
                        verteren van voedsel en de voedingsstoffen transporteren
                        naar de cellen. Het gehele proces betreffende vertering
                        noemen we thermogenese. Wanneer het lichaam eten moet
                        verteren kost hem dit per macronutrient verschillende
                        hoeveelheden energie.{" "}
                        <a
                            href={route("blogs.third")}
                            className="text-we-are-yellow"
                        >
                            Eiwitten
                        </a>{" "}
                        kost het lichaam de meeste moeite om te verteren en
                        verhoogt dan ook tijdelijke onze stofwisseling met 20 to
                        30%. Andere macronutriënten zoals koolhydraten en vetten
                        verhogen tijdelijk onze stofwisseling met 3 tot 10%. Dit
                        laat zien dat het eten van voldoende eiwitten van belang
                        is om steeds die extra boost te geven aan je
                        stofwisseling.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        4. Algemene dagelijkse activiteiten onderschatten
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Je totale energieverbruik op een dag wordt bepaald door
                        een aantal factoren zoals je algemene dagelijkse
                        activiteiten (ADA). Dit zijn activiteiten zoals
                        ademhalen, eten, opstaan en dergelijke. In de theorie
                        wordt dit vaak NEAT genoemd wat staat voor non-exercise
                        activity thermogenesis. We denken vaak alleen aan onze
                        sport maar deze ADA bij elkaar opgeteld verhoogt onze
                        calorieën verbranding aanzienlijk. Wanneer je dit dag op
                        dag doet heb je een totaal van honderden calorieën aan
                        het einde van de week die je extra hebt verbrandt. Blijf
                        dus niet stilzitten op je{" "}
                        <a
                            href={route("blogs.eleventh")}
                            className="text-we-are-yellow"
                        >
                            rustdag
                        </a>{" "}
                        maar blijf in beweging al is het maar klein!
                    </p>
                    {/* -- */}
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl">
                        Bibliografie
                    </h3>
                    <p className="mt-4 text-gray-100 break-words">
                        Kirk, E. P. (2009, Mei). Minimal resistance training
                        improves daily energy expenditure and fat oxidation.
                        Opgehaald van{" "}
                        <a
                            href="https://pubmed.ncbi.nlm.nih.gov/19346974/"
                            rel="noopener"
                            className="text-we-are-yellow"
                        >
                            https://pubmed.ncbi.nlm.nih.gov/19346974/
                        </a>
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Redman, L. M. (2009, februari). Opgehaald van{" "}
                        <a
                            href="https://pubmed.ncbi.nlm.nih.gov/19198647/"
                            rel="noopener"
                            className="text-we-are-yellow"
                        >
                            https://pubmed.ncbi.nlm.nih.gov/19198647/
                        </a>
                    </p>
                </div>
                <Contact />
            </div>
        </Blog>
    );
};
